<template>
    <SectionContentLayout>
        <template #close>
          <ActionButton
                @click='close()'
                v-tooltip='"contacts.actions.close"'
                class="close"
                icon="fas fa-times-circle"
            />
        </template>

        <template #header>
            <ContentTitle title="contacts.actions.export"/>
        </template>

        <template #content>
          <div class="form">
              <fieldset>
                  <legend>{{Language.say('contacts.export.title')}}</legend>

                  <div class="column-group">
                      <div class="control-group">
                          <form method="post" ref="exporter_form" class="control">
                              <span class="select-wrapper">
                                  <select name="exportID" v-model="export_id">
                                      <option disabled>{{Language.say('contacts.export.pick_exporter')}}</option>
                                      <option value="104">{{Language.say('contacts.export.export_csv')}}</option>
                                      <option value="vcard30">{{Language.say('contacts.export.export_vcard')}} </option>
                                  </select>

                                  <input name="actionID" type="hidden"  value="export">
                                  <input name="source"   type="hidden"  value="localsql">
                                  <input name="token"    type="hidden" :value="SAPOMailConfig.server.security.csrf_token">
                              </span>
                          </form>
                      </div>
                  </div>
              </fieldset>

              <div class="submit-desktop">
                  <ActionButton
                      class="main-action"
                      icon="fas fa-upload"
                      text='contacts.export.export_file'
                      @click="exportContacts()"
                  />
              </div>
          </div>
        </template>
    </SectionContentLayout>
</template>

<script setup>
  import { onMounted, ref, defineProps } from 'vue';
  import { useRouter }                from 'vue-router';
  import SectionContentLayout         from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import ContentTitle                 from '@/vue/Elements/Content/ContentTitle.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import Language                     from '@/js/Shared/Language/Language.js';
  import SAPOMailConfig               from '@/SAPOMailConfig';

  const props = defineProps({
    contacts_selection : {},
    contacts_view      : {},
    webmail_view       : {},
  })

  const router         = useRouter();  
  const export_id      = ref('104');
  const exporter_form  = ref();

  onMounted(() => {
    exporter_form.value.action = SAPOMailConfig.client.endpoints.contacts.export + '/?app=turba&fn=' + Language.say('contacts.export.export_csv_name');
  })

  const close = () => {
    router.push('/contacts');
  }

  const exportContacts = async () => {
    exporter_form.value.submit();
  }
</script>
